import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const genitalOrgans: AnswerPathTreeNode = {
  path: 'genitalOrgans',
  children: [{ path: 'testsDetails', nodeId: NodeIds.healthInsuredGenitalOrgansTestsDetails }],
};
